module.exports = __webpack_public_path__ + "media/packs/images/flags/KE-c0018d3d131fdce2eb319b6d73825f76.svg";